import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from "@angular/router";

import {HttpCommonService} from "../services/http-common.service";
import {NzMessageService, NzModalService} from "ng-zorro-antd";
import {Injectable} from "@angular/core";
import {GlobalService} from "../services/global.service";
import {ProtocolMsgComponent} from "../components/protocol-msg/protocol-msg.component";

@Injectable()
export class GDProtocolGuard implements CanActivate{

  constructor(private msg: NzMessageService, public http: HttpCommonService,
              private globalService: GlobalService, private router: Router,
              private showModal: NzModalService){}

  canActivate(routerInfo: ActivatedRouteSnapshot, state: RouterStateSnapshot){

    let userId = routerInfo.queryParams['userId'];
    let userName = routerInfo.queryParams['userName'];
    let keyWord = routerInfo.queryParams['keyWord'];
    let fromType = routerInfo.queryParams['fromType'];
    if (userId && userName) {
      return this.http.get("/user/center/xhsRest/getUserInfo",
        {userId: userId, userName: userName, validate: true}).map((res)=>{
        if (res.stateCode == '1') { // 获取到用户名
          if (res.data.isAgree == '1') { // 1:已同意，0：未同意
            return true;
          } else {
            this.showModal.open({
              content: ProtocolMsgComponent,
              width: 600,
              componentParams: {fromType: fromType, userId: userId, userName: userName, keyWord: keyWord},
              onCancel() { },
              onOk() { },
              footer: false
            });
            return false;
          }
        } else {
          this.globalService.goLogin();
        }
      }).first();
    } else {
      this.globalService.goLogin();
    }

  }


}



// WEBPACK FOOTER //
// E:/java/gd-project/credit-gd-web/src/app/guard/GDProtocolGuard.ts